import { React, useEffect, useState, useContext } from 'react';
import {
  Label,
  TextInput,
  Button,
  Flowbite,
  Datepicker,
  Radio,
} from 'flowbite-react';
import {
  buttonTheme,
  centerText,
  datePickerTheme,
} from '../components/themes.js';
import { AuthContext } from '../context/AuthContext.js';
import { firestore } from '../firebase/FirebaseConfig';
import { doc, onSnapshot } from 'firebase/firestore';
import { ChatContext } from '../context/ChatContext';
import SearchChat from '../components/SearchChat.jsx';
import { useNavigate } from 'react-router';

const MessagesChat = () => {
  const [chats, setChats] = useState([]);
  const { currentUser } = useContext(AuthContext);
  const { dispatch } = useContext(ChatContext);
  const navigate = useNavigate();
  useEffect(() => {
    const getChats = () => {
      const unsubscribe = onSnapshot(
        doc(firestore, 'userChats', currentUser.uid),
        (doc) => {
          setChats(doc.data());
        }
      );
      return () => {
        unsubscribe();
      };
    };
    currentUser.uid && getChats();
  }, [currentUser.uid]);

  const handleSelect = (user) => () => {
    dispatch({ type: 'CHANGE_USER', payload: user });
    navigate(`/messages-chat/${user.uid}`); // navigate to chat room
  };

  return (
    <div className="flex flex-col gap-[20px] box-container messageChat">
      <h1 className="text-3xl">
        Messages<span className="span-titles">Box</span>
      </h1>
      <SearchChat />
      <div className="chats">
        {Object.entries(chats)
          ?.sort((a, b) => b[1].date - a[1].date)
          .map((chat) => {
            return (
              <div
                className="found_results"
                key={chat[0]}
                onClick={handleSelect(chat[1].userInfo)}
              >
                <img src={chat[1].userInfo?.photoURL} alt="" />
                <div className="chatUser_info">
                  <span>{chat[1].userInfo?.displayName}</span>
                  <p>{chat[1].lastMessage?.text}</p>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default MessagesChat;
